import React from 'react';
import PropTypes from 'prop-types';
import { branch, compose, renderComponent } from 'recompose';

import { Refresh } from 'components/svg';
import { Text } from 'components/core/Text';
import { Button } from 'components/core/Button';
import SearchOnMove from './SearchOnMove';

export function RedoSearch({ onRedoSearch }) {
	return (
		<Button
			className="search-on-move-container redo"
			onClick={onRedoSearch}
		>
			<Refresh />
			<Text>Redo search in map</Text>
		</Button>
	);
}

RedoSearch.propTypes = {
	onRedoSearch: PropTypes.func
};

export const enhance = compose(
	branch(
		({ showRedoButton }) => showRedoButton,
		renderComponent(RedoSearch),
		renderComponent(SearchOnMove)
	)
);
export default enhance();
